import vazio from '../../assets/caixa-vazia.png'


export default function UserTable ({ tableData, onEdit, onResetPassword, resettingUserId }){

    return(tableData?
        (
        <table className='table-pattern-sistem w-[100%] borda-cinza mt-4'>

            <thead className='bg-neutro'>
                <tr>
                    <th></th>
                    <th>Nome</th>
                    <th>Ferrovia</th>
                    <th>Usuário</th>
                    <th>Email</th>
                    <th>Grupo</th>
                    <th>Ações</th>
                </tr>
            </thead>

            <tbody>

                {tableData.map(userData => (

                    <tr key={userData.id}>
                        <td>{userData.id}</td>
                        <td>{userData.fullName}</td>
                        <td>{userData.ownerRailway?.name}</td>
                        <td>{userData.username}</td>
                        <td>{userData.email}</td>
                        <td>{userData.ownerGroup?.name}</td>
                        <td>
                            <div className="flex items-center gap-3 whitespace-nowrap">
                                <button
                                    type="button"
                                    onClick={() => onEdit(userData)}
                                    className="text-[#004B9B] underline"
                                >
                                    Editar
                                </button>

                                <span className="text-gray-300">|</span>

                                <button
                                    type="button"
                                    disabled={resettingUserId === userData.id}
                                    onClick={() => onResetPassword(userData)}
                                    className="text-[#004B9B] underline disabled:cursor-wait disabled:opacity-50"
                                >
                                    {resettingUserId === userData.id ? 'Redefinindo...' : 'Redefinir senha'}
                                </button>
                            </div>
                        </td>
                    </tr>

                ))}

            </tbody>

        </table>
        )
        :(

        <div className='flex flex-col w-full items-center justify-center pt-[30px] pb-[20px]'>
            <img className="" alt="Vazio" width="150px" height="150px" src={vazio} />
            <h2 className="text-[#004B9B]">Não há dados.</h2>
        </div>


    ))
}
